// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-fullscreen>.vm--modal{top:0!important;left:0!important;width:100%!important;height:100%!important}.modal-fullscreen>.vm--modal>.v-modal--content{width:100%;height:100%;-webkit-transform:none;transform:none}", ""]);
// Exports
module.exports = exports;
